export default "__VITE_PUBLIC_ASSET__998ea78f__"